import React, { Component } from 'react'

import { IProps } from '@utilities/Field'
import FieldContainer from './FieldContainer'

interface IState {
  day: string
  month: string
  year: string

  // Flags for each select list to enable field
  // to be blurred when all have been touched
  dayTouched: boolean
  monthTouched: boolean
  yearTouched: boolean
}

let yearOptions: any[] = []
const MAX_DATE = new Date().getUTCFullYear()
const MIN_DATE = 1900

for (let i = MAX_DATE; i >= MIN_DATE; i--) {
  yearOptions.push(
    <option key={i} value={i}>
      {String(i)}
    </option>
  )
}

export default class DateField extends Component<IProps, IState> {
  state = {
    day: '',
    month: '',
    year: '',
    dayTouched: false,
    monthTouched: false,
    yearTouched: false
  }

  constructor(props: any) {
    super(props)
    let { value } = this.props.field
    let day = ''
    let month = ''
    let year = ''

    if (value instanceof Date) {
      day = String(value.getUTCDate()).padStart(2, '0')
      month = String(value.getUTCMonth() + 1).padStart(2, '0')
      year = String(value.getUTCFullYear())
    }

    this.state = {
      day: day,
      month: month,
      year: year,
      dayTouched: day !== '',
      monthTouched: month !== '',
      yearTouched: year !== ''
    }
  }

  displayName = 'DateField'

  handleFocus = () => {
    const { name, onFocus } = this.props
    if (onFocus) {
      onFocus(name)
    }
  }

  handleBlur = (ev: any) => {
    const { name } = this.props
    const { dayTouched, monthTouched, yearTouched } = this.state
    const allTouched = dayTouched && monthTouched && yearTouched

    // Only blur if all select lists have been touched
    // or if the value has been changed to blank (for cases where it is required).
    if (allTouched || ev.target.value === '') {
      this.props.onBlur(name)
    }
  }

  handleDayChange = (ev: any) => {
    let { name } = this.props
    let day = ev.target.value
    this.setState(
      {
        day: day,
        dayTouched: true
      },
      () => {
        let { month, year } = this.state
        let newDate: Date | null = new Date(`${year}-${month}-${day}`)
        let invalidDate = isNaN(newDate.getTime())
        if (invalidDate || !day || !month || !year) {
          newDate = null
        }
        this.props.onChange(name, newDate)
      }
    )
  }

  handleMonthChange = (ev: any) => {
    let { name } = this.props
    let month = ev.target.value
    this.setState(
      {
        month: month,
        monthTouched: true
      },
      () => {
        let { day, year } = this.state
        let newDate: Date | null = new Date(`${year}-${month}-${day}`)
        let invalidDate = isNaN(newDate.getTime())
        if (invalidDate || !day || !month || !year) {
          newDate = null
        }
        this.props.onChange(name, newDate)
      }
    )
  }

  handleYearChange = (ev: any) => {
    let { name } = this.props
    let year = ev.target.value
    this.setState(
      {
        year: year,
        yearTouched: true
      },
      () => {
        let { day, month } = this.state
        let newDate: Date | null = new Date(`${year}-${month}-${day}`)
        let invalidDate = isNaN(newDate.getTime())
        if (invalidDate || !day || !month || !year) {
          newDate = null
        }
        this.props.onChange(name, newDate)
      }
    )
  }

  render() {
    const { field, name, info, icon, label, optional } = this.props
    let { day, month, year } = this.state

    return (
      <FieldContainer field={field} info={info} icon={icon} label={label} optional={optional}>
        <div className="DateField">
          <label>
            <span className="-mod-accessibility-text">Day</span>
            <select
              id={name}
              className="Select"
              value={day}
              onChange={this.handleDayChange}
              onFocus={this.handleFocus}
              onBlur={this.handleBlur}
            >
              <option value=""></option>
              <option value="01">1</option>
              <option value="02">2</option>
              <option value="03">3</option>
              <option value="04">4</option>
              <option value="05">5</option>
              <option value="06">6</option>
              <option value="07">7</option>
              <option value="08">8</option>
              <option value="09">9</option>
              <option value="10">10</option>
              <option value="11">11</option>
              <option value="12">12</option>
              <option value="13">13</option>
              <option value="14">14</option>
              <option value="15">15</option>
              <option value="16">16</option>
              <option value="17">17</option>
              <option value="18">18</option>
              <option value="19">19</option>
              <option value="20">20</option>
              <option value="21">21</option>
              <option value="22">22</option>
              <option value="23">23</option>
              <option value="24">24</option>
              <option value="25">25</option>
              <option value="26">26</option>
              <option value="27">27</option>
              <option value="28">28</option>
              <option value="29">29</option>
              <option value="30">30</option>
              <option value="31">31</option>
            </select>
          </label>
          <label>
            <span className="-mod-accessibility-text">Month</span>
            <select
              className="Select"
              value={month}
              onChange={this.handleMonthChange}
              onFocus={this.handleFocus}
              onBlur={this.handleBlur}
            >
              <option value=""></option>
              <option value="01">Jan</option>
              <option value="02">Feb</option>
              <option value="03">Mar</option>
              <option value="04">Apr</option>
              <option value="05">May</option>
              <option value="06">Jun</option>
              <option value="07">Jul</option>
              <option value="08">Aug</option>
              <option value="09">Sep</option>
              <option value="10">Oct</option>
              <option value="11">Nov</option>
              <option value="12">Dec</option>
            </select>
          </label>
          <label>
            <span className="-mod-accessibility-text">Year</span>
            <select
              className="Select"
              value={year}
              onChange={this.handleYearChange}
              onFocus={this.handleFocus}
              onBlur={this.handleBlur}
            >
              <option value=""></option>
              {yearOptions}
            </select>
          </label>
        </div>
      </FieldContainer>
    )
  }
}
